export const fightResultsMap = {
  maineventfirstroundwin: {
    label: "Main Event First Round Win",
    score: 5,
    type: "mainevent",
    outcome: "win",
    round: 1,
  },
  maineventfirstroundloss: {
    label: "Main Event First Round Loss",
    score: -5,
    type: "mainevent",
    outcome: "loss",
    round: 1,
  },
  maineventsecondroundwin: {
    label: "Main Event Second Round Win",
    score: 4,
    type: "mainevent",
    outcome: "win",
    round: 2,
  },
  maineventsecondroundloss: {
    label: "Main Event Second Round Loss",
    score: -4,
    type: "mainevent",
    outcome: "loss",
    round: 2,
  },
  maineventthirdroundwin: {
    label: "Main Event Third Round Win",
    score: 3,
    type: "mainevent",
    outcome: "win",
    round: 3,
  },
  maineventthirdroundloss: {
    label: "Main Event Third Round Loss",
    score: -3,
    type: "mainevent",
    outcome: "loss",
    round: 3,
  },
  maineventfourthroundwin: {
    label: "Main Event Fourth Round Win",
    score: 2,
    type: "mainevent",
    outcome: "win",
    round: 4,
  },
  maineventfourthroundloss: {
    label: "Main Event Fourth Round Loss",
    score: -2,
    type: "mainevent",
    outcome: "loss",
    round: 4,
  },
  maineventfifthroundwin: {
    label: "Main Event Fifth Round Win",
    score: 1,
    type: "mainevent",
    outcome: "win",
    round: 5,
  },
  maineventfifthroundloss: {
    label: "Main Event Fifth Round Loss",
    score: -1,
    type: "mainevent",
    outcome: "loss",
    round: 5,
  },
  standardfirstroundwin: {
    label: "Standard First Round Win",
    score: 3,
    type: "standard",
    outcome: "win",
    round: 1,
  },
  standardfirstroundloss: {
    label: "Standard First Round Loss",
    score: -3,
    type: "standard",
    outcome: "loss",
    round: 1,
  },
  standardsecondroundwin: {
    label: "Standard Second Round Win",
    score: 2,
    type: "standard",
    outcome: "win",
    round: 2,
  },
  standardsecondroundloss: {
    label: "Standard Second Round Loss",
    score: -2,
    type: "standard",
    outcome: "loss",
    round: 2,
  },
  standardthirdroundwin: {
    label: "Standard Third Round Win",
    score: 1,
    type: "standard",
    outcome: "win",
    round: 3,
  },
  standardthirdroundloss: {
    label: "Standard Third Round Loss",
    score: -1,
    type: "standard",
    outcome: "loss",
    round: 3,
  },
  decisionwin: {
    label: "Decision Win",
    score: 0,
    type: "special",
  },
  decisionloss: {
    label: "Decision Loss",
    score: 0,
    type: "special",
  },
  nocontest: {
    label: "No Contest",
    score: 0,
    type: "special",
  },
  draw: {
    label: "Draw",
    score: 0,
    type: "special",
  },
};
